import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "../../../library";
import "./languageSelect.scss";

const LanguageSelect = () => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language);
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  return (
    <div className="language-select">
      <Dropdown
        options={[
          { label: "English", value: "en" },
          { label: "Spanish", value: "sp" },
        ]}
        firstOptionIsDefault
        onChange={(value) => {
          setLang(value);
        }}
      />
      {/*<select
        name="lang"
        value={lang}
        onChange={(e: any) => {
          setLang(e.target.value);
        }}
      >
        <option value="en">English</option>
        <option value="sp">Spanish</option>
      </select>*/}
    </div>
  );
};

export default LanguageSelect;
